import React from 'react';
import { Stack } from '@fluentui/react';
import { BiSolidCloudUpload } from 'react-icons/bi';
import BorderIcon from '../../../components/BorderIcon';
import { stackTokens } from '../../../utility/tasks/styles';
import { COLORS } from '../../../utility/tasks/colors';
import { handleTHEMECLR } from '../../../components/BorderImage';
import { baseFontFamilyStyle } from '../../../shared/styles';
import { CmicContext } from '../../../context/CmicContext';

const UploadHeader = ({
	title = { mainHeading: '', subHeading: '' },
	headerContainerStyles,
	headerTextStyle,
	subHeaderTextStyle,
	iconContainerStyles,
	onPressBack,
	onPressUpload,
}) => {
	const { currentOfficeTheme } = React.useContext(CmicContext);
	//Styles
	const headerStyles = {
		fontFamily: baseFontFamilyStyle,
		fontSize: '18px',
		fontWeight: 'normal',
		marginLeft: '0.5rem',
	};

	const uploadIconContainerStyles = {
		display: 'flex',
		margin: '1px 0',
		padding: '3px 4px',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
	};

	return (
		<Stack
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				width: '100%',
				paddingTop: '0.5rem',
				...headerContainerStyles,
			}}
			horizontal
			tokens={stackTokens}
		>
			<Stack horizontal style={{ flex: 1, display: 'flex' }}>
				<BorderIcon
					iconStyles={{
						color: COLORS.OUTLOOK_PRIMARY_BUTTON_COLOR,
						fontWeight: 'bold',
						fontSize: '18px',
					}}
					iconName="Back"
					onClick={onPressBack}
				/>
				<Stack style={{ display: 'flex-inline', justifyContent: 'space-between' }}>
					<strong style={{ ...headerStyles, ...headerTextStyle }}>{title.mainHeading}</strong>
					<strong style={{ ...headerStyles, ...subHeaderTextStyle }}>{title.subHeading}</strong>
				</Stack>
			</Stack>

			<Stack
				className={handleTHEMECLR(currentOfficeTheme)}
				variant="contained"
				disableElevation
				onClick={onPressUpload}
				style={{ ...uploadIconContainerStyles, ...iconContainerStyles }}
			>
				<BiSolidCloudUpload
					style={{
						color: COLORS.PURPLE,
						height: '25px',
						width: '25px',
					}}
				/>
			</Stack>
		</Stack>
	);
};

export default UploadHeader;
